import { FETCH_WORDCLOUD_DATA, TOGGLE_WORDCLOUDMODAL_SHOW, SET_WORDCLOUD_TYPE } from "../actions/wordCloudAction";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const wordCloudReducer = (
    state = {
        showModal: false,
        data: [],
        dataLoading: false,
        dataFetched: false,
        wordcloudType: "frequency",
    },
    action,
) => {
    switch (action.type) {
        case isPending(FETCH_WORDCLOUD_DATA):
            state = {
                ...state,
                dataLoading: true,
            };
            break;
        case isRejected(FETCH_WORDCLOUD_DATA):
            state = {
                ...state,
                dataLoading: false,
            };
            break;
        case isFulfilled(FETCH_WORDCLOUD_DATA):
            // console.log(action.payload)
            state = {
                ...state,
                data: action.payload.aggregations.wordcloud.buckets,
                dataLoading: false,
                dataFetched: true,
            };
            break;
        case TOGGLE_WORDCLOUDMODAL_SHOW:
            state = {
                ...state,
                showModal: action.payload !== undefined ? action.payload : !state.showModal,
            };
            break;
        case SET_WORDCLOUD_TYPE:
            state = {
                ...state,
                wordcloudType: action.payload,
            };
            break;
        default:
            return state;
    }
    return state;
};

export default wordCloudReducer;
